import { g as getHeadElement } from './111f4418.mjs';

function injectScript(source, target) {
  if (source.parentNode && (source.closest("body") || source.closest("head"))) {
    source.parentNode.replaceChild(target, source);
    return target;
  }
  const head = getHeadElement();
  head.insertBefore(target, head.firstChild);
  head.removeChild(target);
  return target;
}
function evalScript(source) {
  const target = document.createElement("script");
  Array.from(source.attributes).forEach((attribute) => {
    target.setAttribute(attribute.name, attribute.value);
  });
  if (source.src) {
    return injectScript(source, target);
  }
  if (source.getAttribute("type") === "module") {
    target.text = source.text;
    return injectScript(source, target);
  }
  const data = source.text || source.textContent || source.innerHTML || "";
  target.type = "text/javascript";
  target.text = data;
  return injectScript(source, target);
}
function executeInlineScripts(element) {
  const scripts = [];
  const ret = element.getElementsByTagName("script");
  for (let i = 0; ret[i]; i += 1) {
    if (!ret[i].type || ret[i].type.toLowerCase() === "text/javascript" || ret[i].type === "module") {
      scripts.push(ret[i]);
    }
  }
  scripts.forEach(evalScript);
}

var index = /*         */Object.freeze({
  __proto__: null,
  evalScript: evalScript,
  executeInlineScripts: executeInlineScripts
});

export { executeInlineScripts as a, evalScript as e, index as i };
/*                                 */
